<template>
  <div class="student-data__component">
    <div class="student-view__panel-content">
      <div :hidden="!requestError" class="alert alert-danger" role="alert">
        Ocorreu um erro ao enviar a requisição, tente novamente.
      </div>
      <div :hidden="!formError" class="alert alert-danger" role="alert">
        Por favor, preencha o formulário corretamente.
      </div>
      <div class="panel__row">
        <student-info
          label="Nome"
          :value="dataForm.getValue('name')"
          :enable="enableDataInput"
          @inputed="dataForm.addValues({ name: $event })"
        />
        <student-info
          label="CPF"
          :value="dataForm.getValue('cpf')"
          :enable="false" :filter="'cpf'"
          @inputed="dataForm.addValues({ cpf: $event })"
        />
        <student-info
          label="Gênero"
          :value="dataForm.getValue('gender')"
          :enable="enableDataInput" :filter="'gender'"
          :options="options.gender"
          @inputed="dataForm.addValues({ gender: $event })"
        />
      </div>
      <div class="panel__row">
        <student-info
          label="Data de nascimento"
          :value="dataForm.getValue('bornDate')"
          :enable="enableDataInput"
          :filter="'birth'"
          @inputed="dataForm.addValues({ bornDate: $event })"
        />
        <student-info
          label="Estado Civil"
          :value="dataForm.getValue('maritalStatus')"
          :enable="enableDataInput" :filter="'marital'"
          :options="options.marital"
          @inputed="dataForm.addValues({ maritalStatus: $event })"
        />
        <student-info
          label="Telefone"
          :value="dataForm.getValue('cellphone')"
          :enable="enableDataInput"
          :filter="'phone'"
          @inputed="dataForm.addValues({ cellphone: $event })"
        />
      </div>
      <div class="panel__row">
        <student-info
          label="E-mail"
          :value="dataForm.getValue('email')"
          :enable="enableDataInput"
          :filter="'email'"
          @inputed="dataForm.addValues({ email: $event })"
        />
      </div>
    </div>
    <div class="panel__rstudentow">
      <div v-if="tabName == 'personalData'" class="dropdown" :hidden="enableDataInput">
        <button
          class="btn btn-primary dropleft-toggle"
          type="button"
          data-toggle="dropdown"
        >
          Ações
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-left">
          <li>
            <a @click="editDataInput()">
              Editar as informações
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div :hidden="!enableDataInput">
      <button class="btn btn-primary" type="button" @click="updateData()">
        Salvar
      </button>
      <button class="btn btn-primary" type="button" style="margin-left: 1%" @click="cancelDataUpdate()">
        Cancelar
      </button>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';
import { FormGroup } from 'utils/form';
import ParcelamentoService from '../../../../services/ParcelamentoService';

export default {
  components: {
    StudentInfo,
  },
  data() {
    return {
      dataForm: new FormGroup({
        phoneCountryCode: { },
        phoneAreaCode: { },
        phoneNumber: { },
        name: { required: true, fullName: true, onlyLettersAndSpaces: true },
        cpf: { required: true, cpf: true },
        gender: { required: true },
        genderTranslated: { required: true },
        bornDate: {
          required: true, date: true, minLength: 10, maxLength: 10, maxAge: 80,
        },
        maritalStatus: { required: true },
        maritalStatusTranslated: { required: true },
        cellphone: {
          required: true,
          minLength: 15,
          maxLength: 15,
          ignoreOnRawValue: true,
        },
        email: { email: true, required: true },
      }),
      enableDataInput: false,
      cancelDataInput: false,
      formError: false,
      requestError: false,
    };
  },
  props: {
    student: {
      type: Object,
      default: () => {},
    },
    personalData: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    tabName: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.refreshFormFields();
  },
  methods: {
    refreshFormFields() {
      if (this.personalData.cellphone) {
        this.dataForm.addValues({
          ...this.personalData,
          cellphone: this.personalData.cellphone.slice(2),
          phoneCountryCode: this.personalData.cellphone.slice(0, 2),
          phoneAreaCode: this.personalData.cellphone.slice(2, 4),
          phoneNumber: this.personalData.cellphone.slice(4),
        });
      }
    },
    updateCellphoneFields() {
      this.dataForm.addValues({
        phoneCountryCode: '55',
        phoneAreaCode: this.dataForm.getValue('cellphone').slice(1, 3),
        phoneNumber: this.dataForm.getValue('cellphone').slice(5).split('-').join(''),
      });
    },
    editDataInput() {
      this.enableDataInput = true;
      this.cancelDataInput = false;
    },
    cancelDataUpdate() {
      this.requestError = false;
      this.formError = false;
      this.enableDataInput = false;
      this.cancelDataInput = true;
      this.refreshFormFields();
    },
    updateData() {
      if (this.dataForm.validateForm()) {
        this.updateCellphoneFields();
        this.formError = false;
        if (this.tabName === 'personalData') {
          ParcelamentoService.updatePersonalData(this.personalData.id, this.dataForm.getRawValue())
            .then(() => {
              this.enableDataInput = false;
              this.cancelDataInput = false;
              this.requestError = false;
              this.$emit('form-update', this.dataForm.getRawValue(true));
            })
            .catch(() => {
              this.requestError = true;
            });
        }
      } else {
        this.formError = true;
      }
    },
  },
};
</script>
